<div class="flex flex-col -m-6">

  <!-- Header -->
  <div
    class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    @if (data.title) {
      <div class="text-lg font-medium">{{ data.title | localize }}</div>
    }
    @if (!data.title) {
      <div class="text-lg font-medium">{{ (data.values ? 'updateRow' : 'createRow') | transloco }}</div>
    }
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" svgIcon="mat_outline:close"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <dtype-component-list class="p-4" [dtypeForm]="form" [isUpdate]="data.isUpdate"></dtype-component-list>

  <!-- Actions -->
  <div class="flex flex-col sm:flex-row justify-end gap-2 px-4 pb-2 sm:px-8 sm:pb-8 w-full">
    <button (click)="closeDialog()" mat-stroked-button>
      {{ 'cancel' | transloco }}
    </button>
    <button (click)="save()" mat-flat-button color="primary">
      {{ 'save' | transloco }}
    </button>
  </div>
</div>